module.exports = __webpack_public_path__ + "static/img/4_1_2.33d0224e.jpg";